<template>
  <div class="vue_flex vue_column">
    <div class="cont_wrapper">
      <div class="cont_wrapper_sx">
        <div class="shaixuan_left">
          <div class="shaixuan_item h">
            <div class="shaixuan_item_con">
              <img
                class="shaixuan_item_icon"
                src="../../../../../assets/ym/tjsj@2x.png"
                alt=""
              />
              <div class="shaixuan_item_tit">统计时间</div>
            </div>
            <el-date-picker
              v-model="listQuery.time"
              type="datetimerange"
              range-separator=""
              start-placeholder=""
              end-placeholder=""
              value-format="timestamp"
              class="vue_flex_item"
              placeholder="选择日期"
            ></el-date-picker>
          </div>
          <div class="shaixuan_item h">
            <div class="shaixuan_item_con">
              <img
                class="shaixuan_item_icon"
                src="../../../../../assets/ym/dp@2x.png"
                alt=""
              />
              <div class="shaixuan_item_tit">渠道</div>
            </div>
            <el-select
              v-model="listQuery.type"
              placeholder="请选择"
              class="vue_flex_item"
            >
              <el-option
                v-for="item in qudaooptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div class="shaixuan_item h">
            <div class="shaixuan_item_con">
              <img
                class="shaixuan_item_icon"
                src="../../../../../assets/ym/dp@2x.png"
                alt=""
              />
              <div class="shaixuan_item_tit">店铺</div>
            </div>
            <el-select
              v-model="listQuery.shopid"
              placeholder="请选择"
              class="vue_flex_item"
            >
              <el-option
                v-for="item in dpList"
                :key="item.shopid"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="shaixuan_btns">
          <div class="shaixuan_btn1 h" @click="qingchu">清除</div>
          <div class="shaixuan_btn2 h" @click="search">查询</div>
        </div>
      </div>
      <div class="home_title">
        <div class="home_tit">经营报表-核心指标趋势图</div>
        <!-- <div class="home_right">
          <div class="home_right_1">
            <div>日</div>
            <img src="../../../../../assets/ym/xl@2x.png" alt="" />
          </div>
          <img
            class="home_right_2"
            src="../../../../../assets/ym/gd@2x.png"
            alt=""
          />
        </div> -->
      </div>

      <linkwhole :list="linkList" @itemClick="linkboxsClick"></linkwhole>

      <div id="myChart"></div>

      <div class="home_title">
        <div class="home_tit">经营报表-渠道-支付</div>
      </div>

      <el-table
          :data="tableData"
          style="width: 100%"
          :header-cell-style="{ backgroundColor: '#f5f7fa', color: '#333' }"
          :span-method="(...arg) => strategySpanMethod(...arg, tableData)"
          key="paycaliber"
        >
          <el-table-column
            fixed
            prop="riqi"
            label="统计时间"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="qudaoName"
            label="渠道"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="shopName"
            label="店铺名称"
            align="center"
          ></el-table-column>
          
          <el-table-column
            prop="xiaoshoushouru"
            label="销售收入（去退）"
            align="center"
          ></el-table-column>
          
          <el-table-column
            prop="xianshangguanggaotoufangfeiyong"
            label="线上广告投放费用"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="guanggaobi"
            label="广告投放费比"
            align="center"
          ></el-table-column>
          
          <el-table-column
          prop="guanggaodianjilv"
          label="广告点击率%"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="guanggaotoufangbaoguang"
          label="广告投放曝光量"
          align="center"
        ></el-table-column>
         <el-table-column
          prop="guanggaotoudangdianji"
          label="广告投放点击量"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="guanggaogmv"
          label="广告成交金额GMV占比%"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="guanggaoroi"
          label="广告成交ROI%"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="guanggaodianjizhuanhua"
          label="广告点击转化%"
          align="center"
        ></el-table-column>
        </el-table>
      <pagination
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        @pagination="getHetongListFun"
      />
    </div>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import * as echarts from "echarts";
import Pagination from "@/components/Pagination"; // secondary package based on el-pagination
import linkwhole from "@/components/linkwhole/index";
import DonMessage from "@/utils/message";

export default {
  components: { Pagination, linkwhole },
  data() {
    return {
      dpList: [],
      qudaooptions: [
        { value: "1", label: "淘宝" },
        { value: "2", label: "京东" },
        { value: "3", label: "拼多多" },
      ],
      total: 0,
      listQuery: {
        time: [],
        type: "3",
        shopid: "",
      },
      listQuery1: {
        page: 1,
        limit: 10,
        leixing: "",
      },

      charts: "",
      opinionData: ["3", "2", "4", "4", "5"],
      linkList: [
        {
          tit: "广告投放花费",
          num: "",
        },
        {
          tit: "广告投放成交金额",
          num: "",
        },
        {
          tit: "销售收入",
          num: "",
        },
        {
          tit: "广告GMV占比",
          num: "",
        },
        {
          tit: "广告投放ROI",
          num: "",
        },
        {
          tit: "广告投放费比",
          num: "",
        },
        {
          tit: "广告点击率（CTR）",
          num: "",
        },
        {
          tit: "点击成交转化",
          num: "",
        },
        {
          tit: "广告投放曝光量",
          num: "",
        },
        {
          tit: "广告投放点击量",
          num: "",
        },
      ],

      userObj: {},
      tableData: [],
      riqiSpanArr: [],

    };
  },
  created() {
    this.getList();
    this.getdpListFun();
    this.getzftb();
    this.getdataList();
  },

  methods: {
    getSpanArr(data, spanKey) {
      var spanArr = [];
      var pos = "";
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          spanArr.push(1);
          pos = 0;
        } else {
          // 判断当前元素与上一个元素是否相同
          if (data[i][spanKey] === data[i - 1][spanKey]) {
            spanArr[pos] += 1;
            spanArr.push(0);
          } else {
            spanArr.push(1);
            pos = i;
          }
        }
      }
      return spanArr;
    },
    // 合并单元格函数
    strategySpanMethod: function (
      { row, column, rowIndex, columnIndex },
      data
    ) {
      if (columnIndex !== 0) return;
      // data 就是从这里动态传过来的, column.property是表头的key
      var spanArr = this.getSpanArr(data, column.property);
      const _row = spanArr[rowIndex];
      const _col = _row > 0 ? 1 : 0;
      return {
        rowspan: _row,
        colspan: _col,
      };
    },

    async getdataList() {
      let params = {
        page: this.listQuery1.page,
        limit: this.listQuery1.limit,
        leixing: "zhichu",
        starttime:
          this.listQuery.time.length > 0 ? this.listQuery.time[0] / 1000 : "",
        endtime:
          this.listQuery.time.length > 0 ? this.listQuery.time[1] / 1000 : "",
      };
      const res = await this.$http.get(this.$urls.lirunribao_excel, params);
      if (res.errcode != 0) return DonMessage.error(res.errmsg);
      res.allData.forEach((dateItem) => {
        const { riqi, qudao } = dateItem;
        // 遍历每个渠道
        qudao.forEach((channelItem) => {
          const { name: qudaoName, shopList } = channelItem;
          // 渠道无店铺时，生成空店铺行（保证日期合并完整性）
          if (shopList.length === 0) {
            this.tableData.push({
              riqi,
              qudaoName,
              shopName: "-",
              guanggaotoufangchengjiaojine: 0,
              guanggaogmv: 0,
              guanggaoroi: 0,
              guanggaodianjizhuanhua: 0,
              guanggaodianjilv: 0,
              guanggaotoufangbaoguang: 0,
              guanggaotoudangdianji: 0,
            });
          } else {
            // 有店铺时，遍历店铺生成行
            shopList.forEach((shopItem) => {
              this.tableData.push({
                riqi,
                qudaoName,
                ...shopItem,
                // shopName: shopItem.name,
                // xiaoshoushouru: shopItem.xiaoshoushouru,
                // xiaoshounum: shopItem.xiaoshounum,
                // dingdannum: shopItem.dingdannum,
                // maolilv: shopItem.maolilv,
                // maolirun: shopItem.maolirun,
                // yewu: shopItem.yewu,
              });
            });
          }
        });
      });
    },
    search() {
      this.getList();
      this.getzftb();
      this.tableData = [];
      this.getdataList();
    },

    linkboxsClick(msg) {
      this.$nextTick(function () {
        this.drawLine("myChart", msg.tubiao);
      });
    },

    async getzftb() {
      const res = await this.$http.get(this.$urls.lirunribao_zhifu_echart, {
        type: this.listQuery.type,
        shopid: this.listQuery.shopid,
      });
      if (res.errcode != 0) return DonMessage.error(res.errmsg);
      for (let key of this.linkList) {
        if (key.tit == "广告投放花费") {
          key.tubiao = res.tuiguangmoneyEcharts
        }
        if (key.tit == "广告投放成交金额") {
          key.tubiao = res.guanggaotoufangchengjiaojineEcharts;
        }
        if (key.tit == "销售收入") {
          key.tubiao = res.xiaoshoushouruEcharts;
        }
        if (key.tit == "广告GMV占比") {
          key.tubiao = res.guanggaogmvEcharts;
        }
        if (key.tit == "广告投放ROI") {
          key.tubiao = res.guanggaoroiEcharts;
        }
        if (key.tit == "广告投放费比") {
          key.tubiao = res.guanggaobiEcharts;
        }
        if (key.tit == "广告点击率（CTR）") {
          key.tubiao = res.guanggaodianjilvEcharts;
        }
        if (key.tit == "点击成交转化") {
          key.tubiao = res.guanggaodianjizhuanhuaEcharts;
        }
        
        if (key.tit == "广告投放曝光量") {
          key.tubiao = res.guanggaotoufangbaoguangEcharts;
        }
        if (key.tit == "广告投放点击量") {
          key.tubiao = res.guanggaotoudangdianjiEcharts;
        }
      }
      this.$nextTick(function () {
        this.drawLine("myChart", res.yewulirunEcharts);
      });
    },

    async getList() {
      let params = {
        type: this.listQuery.type,
        shopid: this.listQuery.shopid,
        starttime:
          this.listQuery.time.length > 0 ? this.listQuery.time[0] / 1000 : "",
        endtime:
          this.listQuery.time.length > 0 ? this.listQuery.time[1] / 1000 : "",
      };
      const res = await this.$http.post(this.$urls.lirunribao_zhifu, params);
      if (res.errcode != 0) return DonMessage.error(res.errmsg);
      for (let key of this.linkList) {
        if (key.tit == "广告投放花费") {
          key.num = res.tuiguangmoney || '0';
        }
        if (key.tit == "广告投放成交金额") {
          key.num = res.guanggaotoufangchengjiaojine
        }
        if (key.tit == "销售收入") {
          key.num = res.xiaoshoushouru;
        }
        if (key.tit == "广告GMV占比") {
          key.num = res.guanggaogmv + "%"
        }
        if (key.tit == "广告投放ROI") {
          key.num = res.guanggaoroi + "%"
        }
        if (key.tit == "广告投放费比") {
          key.num = res.guanggaobi + "%";
        }
        if (key.tit == "广告点击率（CTR）") {
          key.num = res.guanggaodianjilv + "%"
        }
        if (key.tit == "点击成交转化") {
          key.num = res.guanggaodianjizhuanhua + "%"
        }
        
        if (key.tit == "广告投放曝光量") {
          key.num = res.guanggaotoufangbaoguang
        }
        if (key.tit == "广告投放点击量") {
          key.num = res.guanggaotoudangdianji
        }
      }
    },

    qingchu() {
      this.listQuery = {
        time: [],
        type: "1",
        shopid: "",
      };
      this.getList();
    },

    // 店铺列表
    async getdpListFun() {
      const res = await this.$http.get(this.$urls.getshoplist, {
        page: 1,
        limit: 10000,
      });
      if (res.errcode != 0) return DonMessage.error(res.errmsg);
      this.dpList = res.list;
    },
    drawLine(id, item) {
      this.charts = echarts.init(document.getElementById(id));
      this.charts.setOption({
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: [""],
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "12%",
          containLabel: true,
        },

        xAxis: {
          type: "category",
          boundaryGap: false,
          data: item.x,
        },
        yAxis: {
          type: "value",
        },

        series: [
          {
            name: "近七日收益",
            type: "line",
            stack: "总量",
            data: item.y,
          },
        ],
      });
    },

    getHetongListFun() {},
  },
};
</script>

<style lang="scss" scoped>
#myChart {
  width: 1508px;
  height: 300px;
}

.home_title {
  width: 100%;
  height: 55px;
  margin-top: 15px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  .home_tit {
    font-family: PingFang SC;
    font-weight: bold;
    font-size: 26px;
    color: #232323;
  }
  .home_right {
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    .home_right_2 {
      width: 52px;
      height: 52px;
      border-radius: 50%;
      margin-left: 10px;
    }
    .home_right_1 {
      padding: 0 10px;
      width: 108px;
      height: 45px;
      background: #f4f5f9;
      border-radius: 10px;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
    }
  }
}
.shaixuan_btns {
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  .shaixuan_btn1 {
    width: 132px;
    height: 55px;
    background: #ffffff;
    border-radius: 10px;
    border: 1px solid #999999;
    text-align: center;
    line-height: 55px;
  }
  .shaixuan_btn2 {
    margin-left: 25px;
    width: 131px;
    height: 54px;
    background: #195cf8;
    border-radius: 10px;
    text-align: center;
    line-height: 55px;
    font-family: PingFang SC;
    font-weight: 500;
    font-size: 20px;
    color: #ffffff;
  }
}
.cont_wrapper {
  padding: 25px;
  .cont_wrapper_sx {
    width: 1527px;
    height: 71px;
    background: #f5f5f5;
    border-radius: 10px;
    padding: 0 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .shaixuan_left {
      display: flex;
      flex-direction: row;
      justify-content: start;
      align-items: center;
    }
    .shaixuan_item {
      width: 350px;
      height: 54px;
      background: #ffffff;
      border-radius: 10px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      margin-right: 22px;
      .shaixuan_item_con {
        display: flex;
        flex-direction: row;
        justify-content: start;
        align-items: center;
        .shaixuan_item_tit {
          font-family: PingFang SC;
          font-weight: 500;
          font-size: 18px;
          color: #232323;
        }
        .shaixuan_item_sel {
          font-family: PingFang SC;
          font-weight: 500;
          font-size: 18px;
          color: #999999;
        }
        .shaixuan_item_arr {
          width: 13px;
          height: 8px;
          margin-left: 10px;
        }
        .shaixuan_item_icon {
          width: 29px;
          height: 24px;
          margin-right: 10px;
        }
      }
    }
  }
}

.shaixuan_item {
  /deep/ .el-date-editor {
    border: none !important;
    text-align: right;
    font-size: 18px;
    width: 196px;
  }

  /deep/ .el-input__icon {
    display: none;
  }

  .el-input /deep/.el-input__inner {
    border: none !important;
    text-align: right;
    font-size: 18px;
  }
  .el-input /deep/.el-input__prefix {
    display: none !important;
  }

  .el-select /deep/.el-input__inner {
    border: none !important;
    text-align: right;
    font-size: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/main/level1/pinduoduo/pddpopularize/index.vue